import makeId from './makeId';

export function createTraceId(operation: string): string {
	return `${window.sessionTraceId}:${window.currentRoute}:${operation}:${makeId(5)}`;
}
